// src/pages/Contact.jsx
import Layout from "../layouts/Layout";
import Breadcrumb from "../components/Breadcrumb";
import ContactInfoSection from "../components/Contact/ContactInfoSection";
import ContactSection from "../components/Contact/ContactSection";

const Contact = () => (
  <Layout>
    <Breadcrumb
      title="Liên hệ"
      parent={{ name: "Trang chủ", path: "/" }}
    />

    <ContactInfoSection />
    <ContactSection />
  </Layout>
);

export default Contact;
